import { StrapiFile } from "types/StrapiFile";

export const isStrapiDocument = (image: StrapiFile) =>
  ![".png", ".jpg", ".jpeg", ".webp"].includes(image?.ext);

export default isStrapiDocument;
